import Vue from 'vue'

export const formatDate = (date, fmt) => {
    if (date === '' || date === undefined) {
        return ''
    }
    date = date.toString().replace(/-+/g, '/')
    const newDate = new Date(date)
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (newDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    const o = {
        'M+': newDate.getMonth() + 1,
        'd+': newDate.getDate(),
        'h+': newDate.getHours(),
        'm+': newDate.getMinutes(),
        's+': newDate.getSeconds()
    }
    for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            const str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
        }
    }
    return fmt
}

function padLeftZero(str) {
    return ('00' + str).substr(str.length)
}

export function formatNumber(data) {
    if (data == null || data == undefined) {
        return ''
    }
    const parts = data.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join('.')
}

export function toFixed(number, length = 2) {
    return number.toFixed(length)
}

const filters = {
    formatDate,
    formatNumber,
    toFixed
}
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
export default filters
